/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: inboundRoutesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Calls Routing module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteInboundRoute } from './api/inboundRouteApi';

/**
 * Shared helpers for Inbound Routes actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an Inbound Route in the form.
 * Pattern: /pbx/calls-routing/inbound/new?duplicate={id}
 */
export const getInboundRouteDuplicateUrl = (id: string | number): string =>
  `/pbx/calls-routing/inbound/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Inbound Route id.
 */
export const navigateToInboundRouteDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getInboundRouteDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an Inbound Route by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteInboundRouteById = async (id: string | number): Promise<void> => {
  await deleteInboundRoute(id);
};



